import {
  CalloutBox,
  CalloutText,
  ErrorDescription,
  ErrorTitle,
} from "./FailedValidationNotifications.styles"

export interface FailedValidationReason {
  validationName: string
  validationDescription: string
}

export interface Props {
  validationFailures: FailedValidationReason[]
}

export default function FailedValidationNotifications(props: Props) {
  return (
    <CalloutBox>
      <>
        <CalloutText>
          This invoice failed validation for the following{" "}
          {props.validationFailures.length > 1
            ? props.validationFailures.length + " "
            : ""}
          reason{props.validationFailures.length > 1 ? "s" : ""}:
        </CalloutText>
        {props.validationFailures.map((failure) => {
          return (
            <>
              <ErrorTitle>{failure.validationName}</ErrorTitle>
              <ErrorDescription>
                {failure.validationDescription}
              </ErrorDescription>
            </>
          )
        })}
      </>
    </CalloutBox>
  )
}
